<template>
  <div class="cpe-banner">
    <div class="cpe-banner__container">
      <ConfettiExplosion
        v-if="isCompleted"
        class="cpe-banner__cofetti-animation"
      />
      <div class="cpe-banner__label-container">
        <p
          class="cpe-banner__title"
          :class="{
            'cpe-banner__title--align-center': !showButtonsContainer,
          }"
        >
          <template v-if="isCompleted">
            Congratulations! You've completed this {{ contentType }} and earned
            {{ content.cpe_credits }} CPE credits!
          </template>
          <template v-else>
            You’re almost there! Complete this {{ contentType }} to earn
            {{ content.cpe_credits }} CPE credits!
          </template>
        </p>
        <p v-if="canRateContent" class="cpe-banner__subtitle">
          <template v-if="isRatingConfirmed">
            Check your
            <router-link
              class="cpe-banner__subtitle-action"
              :to="{
                name: 'user-dashboard',
                params: { mode: 'certifications' },
              }"
            >
              profile
            </router-link>
            to see all your credits.
          </template>
          <template v-else>
            We value your feedback—care to
            <span
              class="cpe-banner__subtitle-action"
              @click="$emit('open-rating-modal')"
            >
              rate and review</span
            >?
          </template>
        </p>
      </div>
      <div v-if="showButtonsContainer" class="cpe-banner__buttons-container">
        <router-link
          v-if="isCompleted"
          class="cpe-banner__button btn btn--secondary btn--small"
          :to="{
            name: 'user-dashboard',
            params: { mode: 'certifications' },
          }"
        >
          See CPE credits
        </router-link>
        <button
          v-if="canRateContent && !isRatingConfirmed"
          class="cpe-banner__button btn btn--secondary btn--small btn--default-icon-color"
          @click="$emit('open-rating-modal')"
        >
          <StarIcon />Rate and review
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { StarIcon } from 'vue-feather-icons'
import CONSTANTS from '@/constants'
import ConfettiExplosion from '../shared/ConfettiExplosion.vue'

export default {
  name: 'CpeBanner',
  components: {
    StarIcon,
    ConfettiExplosion,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    isCompleted: {
      type: Boolean,
      default: false,
    },
    canRateContent: {
      type: Boolean,
      default: true,
    },
    isRatingConfirmed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showButtonsContainer() {
      return (
        this.isCompleted || (this.canRateContent && !this.isRatingConfirmed)
      )
    },
    contentTypeLabel() {
      const { CONTENT_TYPES } = CONSTANTS

      switch (this.contentType) {
        case CONTENT_TYPES.LAB:
          return this.content.is_lab_experience ? 'Skill Dive Lab' : 'Lab'
        case CONTENT_TYPES.LEARNING_PATH:
          return 'Learning Path'
        default:
          return (
            this.contentType.charAt(0).toUpperCase() + this.contentType.slice(1)
          )
      }
    },
  },
}
</script>

<style scoped lang="scss">
.cpe-banner {
  position: fixed;
  bottom: 0;
  z-index: 250;
  width: 100%;
  padding: 10px 100px;
  background: linear-gradient(0deg, var(--black-40) 0%, var(--black-40) 100%),
    var(--glass-purple);

  &__container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    position: relative;
  }
  &__cofetti-animation {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
  }
  &__label-container {
    flex: 1;
    p {
      margin: 0;
    }
  }
  &__title {
    color: var(--dusty-gray);
    font-feature-settings: 'liga' off, 'clig' off;

    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.4375rem;

    &--align-center {
      text-align: center;
    }
  }
  &__subtitle {
    color: var(--light-blue-gray);
    font-feature-settings: 'liga' off, 'clig' off;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 450;
    line-height: 1.25rem;

    &-action {
      color: var(--purple-pale);
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__buttons-container {
    display: flex;
    gap: 10px;
  }
}
</style>
